import LegalPage from "@/components/site/LegalPage";

export default function Refund() {
  return (
    <LegalPage
      eyebrow="Refund Policy"
      title="No Refund Policy"
    >
      <p className="mb-5">
        MyAdventure-Passport currently offers paid subscription plans and
        premium in-app features. The application does not provide campsite
        booking or reservation services.
      </p>
      <p className="mb-5">
        All subscription fees and payments for premium features made through
        the MyAdventure-Passport application are <strong>final and non-refundable</strong>.
      </p>
      <p className="mb-4">
        Once a subscription has been purchased or renewed, no refunds, partial
        refunds, credits, or exchanges will be provided, including but not
        limited to the following circumstances:
      </p>
      <ul className="list-disc pl-6 space-y-1 mb-5">
        <li>Change of mind after purchase.</li>
        <li>Partial or non-use of the subscription during the subscription period.</li>
        <li>Accidental purchase by the user.</li>
        <li>Cancellation of the subscription before the end of the billing period.</li>
        <li>Failure to use the premium features available under the subscription.</li>
      </ul>
      <p className="mb-5">
        Users are encouraged to review the subscription plan, pricing,
        features, and billing terms carefully before completing their purchase.
      </p>
      <p className="mb-8">
        If you believe you have been charged due to a verified technical error,
        duplicate transaction, or unauthorized payment, please contact
        MyAdventure-Passport Customer Support. Such cases will be investigated
        individually, and any appropriate resolution will be determined at
        MyAdventure-Passport's sole discretion.
      </p>
      <p
        className="p-5 rounded-2xl"
        style={{ background: "var(--surface-secondary)", border: "1px solid var(--border-c)" }}
      >
        By purchasing a subscription or premium feature through the
        MyAdventure-Passport application, you acknowledge that you have read,
        understood, and agreed to this Refund Policy.
      </p>
    </LegalPage>
  );
}
